import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { useFunds } from '@/react-query/queries/funds/funds'

export interface FundIdFieldProps {}

export const FundIdField: React.FC<FundIdFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ fund_id: number }>()

  const {
    data,
    query: { isFetching },
  } = useFunds()

  return (
    <FormField
      name="fund_id"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Fund</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={isFetching}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select a fund'}
              value={value?.toString()}
              setValue={(value) => setValue('fund_id', parseInt(value), { shouldValidate: true })}
              options={data.map((fund) => ({
                label: fund.fund_name,
                value: fund.fund_id?.toString(),
              }))}
            />
          </FormItem>
        )
      }}
    />
  )

  return <></>
}
